import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { DocumentDelivery } from '../shared/model/document-delivery.model';
import { MatTableDataSource } from '@angular/material';

@Component({
  selector: 'app-document-delivery',
  templateUrl: './document-delivery.component.html',
  styleUrls: ['./document-delivery.component.scss']
})
export class DocumentDeliveryComponent implements OnInit , OnChanges {

  displayedColumns ;
  dataSource;
  @Input() documents: DocumentDelivery[];
  @Input() isPifle: boolean;

  constructor() { }

  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.documents);
  }

  ngOnChanges() {
    if (this.isPifle) {
      this.displayedColumns = ['requisito', 'archivo' , 'recibido'];
    } else {
      this.displayedColumns = ['requisito', 'recibido'];
    }
    this.dataSource = new MatTableDataSource(this.documents);
  }

}
